import { DateTime } from 'luxon'

import { GooglePlaceData } from '@core/api/entities/googlePlaceData'
import { Zone } from '@core/api/entities/zone/zone'

export class Location {
	public id: number
	public uuid: string
	public accountId: number
	public accountName?: string
	public name: string
	public country: string
	public address: string | null
	public phoneNumber: string | null
	public email: string | null
	public manager: string | null
	public createdAt: DateTime
	public timezone: string
	public type: string
	public city: string | null
	public zipCode: string | null
	public additionalInformation: string | null
	public idType: string | null
	public idNumber: string | null
	public lastSmartUpdateAt: DateTime | null
	public hasVolumeControl: boolean

	public zones: Zone[]
	public googlePlaceData: GooglePlaceData | null

	constructor(data: {
		id: number
		uuid: string
		accountId: number
		accountName?: string
		name: string
		country: string
		address: string | null
		phoneNumber: string | null
		email: string | null
		manager: string | null
		createdAt: DateTime
		timezone: string
		type: string
		city: string | null
		zipCode: string | null
		additionalInformation: string | null
		idType: string | null
		idNumber: string | null
		lastSmartUpdateAt: DateTime | null
		hasVolumeControl: boolean
		zones: Zone[]
		googlePlaceData: GooglePlaceData | null
	}) {
		this.id = data.id
		this.uuid = data.uuid
		this.accountId = data.accountId
		this.accountName = data.accountName
		this.name = data.name
		this.country = data.country
		this.address = data.address
		this.phoneNumber = data.phoneNumber
		this.email = data.email
		this.manager = data.manager
		this.createdAt = data.createdAt
		this.timezone = data.timezone
		this.type = data.type
		this.city = data.city
		this.zipCode = data.zipCode
		this.additionalInformation = data.additionalInformation
		this.idType = data.idType
		this.idNumber = data.idNumber
		this.lastSmartUpdateAt = data.lastSmartUpdateAt
		this.hasVolumeControl = data.hasVolumeControl
		this.zones = data.zones
		this.googlePlaceData = data.googlePlaceData
	}

	static create(partial: Partial<Location>): Location {
		const defaults = {
			id: 0,
			uuid: '',
			accountId: 0,
			name: '',
			country: '',
			address: null,
			phoneNumber: null,
			email: null,
			manager: null,
			createdAt: DateTime.now(),
			timezone: '',
			type: '',
			city: null,
			zipCode: null,
			additionalInformation: null,
			idType: null,
			idNumber: null,
			lastSmartUpdateAt: null,
			hasVolumeControl: false,

			zones: [],
			googlePlaceData: null,
		}

		// Merge defaults with provided data
		return new Location({ ...defaults, ...partial })
	}
}
